// Re-applies the active state to the sidenav on every Turbo visit.
//
// The sidenav (`#sidenav-menu`) is `data-turbo-permanent`, so Inspinia's one-time
// `initSidenavMenu()` — which matches the current URL on DOMContentLoaded — does not
// re-run on Turbo Drive navigations. This mirrors that URL-matching logic so the
// highlighted item follows navigation, with a path-prefix fallback so nested pages
// (e.g. /clients/5) still highlight their section.

function highlightActiveNavLink() {
  const sideNav = document.querySelector('.side-nav')
  if (!sideNav) return

  const currentPath = window.location.pathname

  // Clear previous active state.
  sideNav.querySelectorAll('a.active, li.active').forEach((el) => el.classList.remove('active'))

  const links = Array.from(sideNav.querySelectorAll('a[href]'))
  const pathOf = (link) => {
    try { return new URL(link.href).pathname } catch (_) { return null }
  }

  // Prefer an exact match; fall back to the deepest section whose path prefixes the URL.
  let match = links.find((l) => pathOf(l) === currentPath)
  if (!match) {
    match = links
      .filter((l) => {
        const p = pathOf(l)
        return p && p !== '/' && (currentPath === p || currentPath.startsWith(p + '/'))
      })
      .sort((a, b) => (pathOf(b)?.length || 0) - (pathOf(a)?.length || 0))[0]
  }
  if (!match) return

  match.classList.add('active')

  // Activate ancestor list items and open parent collapses (matches Inspinia behavior).
  let li = match.closest('li')
  while (li && li !== sideNav) {
    li.classList.add('active')
    const parentCollapse = li.closest('.collapse')
    if (parentCollapse && window.bootstrap) {
      window.bootstrap.Collapse.getOrCreateInstance(parentCollapse, { toggle: false }).show()
      const collapseLi = parentCollapse.closest('li')
      if (collapseLi) collapseLi.classList.add('active')
    }
    const parentLi = li.parentElement ? li.parentElement.closest('li') : null
    li = parentLi
  }
}

document.addEventListener('turbo:load', highlightActiveNavLink)

export { highlightActiveNavLink }
